import { RegistrationProtocol } from "../../../user/registrationProtocol";
import { HubApiError } from "../../../domains/valueObject/SwitchUserProgressResponses";
import Axios from "axios";
import { Url } from "../url";
import { getUrlToLoginViaToken } from "../../../login/getUrlToLoginViaToken";
import { addLoginQueryParams } from "../../../utils/url";
import { GtmSender } from "../../../marketing/GtmSender";
import { systemEvents } from "../../../constants/gameEvents";
import { JRpcResponse } from "../jsonRpc/jsonRpcResponseFactory";
import { RegistrationResponse } from "@scorewarrior/rubens_web_lib/src/hub-api/protocol/registration-req";
import { getProjectNameByCurrentPlatform, ProjectName } from "../../../constants/projectName";
import { HubApiBuilder } from "@scorewarrior/rubens_web_lib/src/hub-api/hub-api-builder";
import { HubInstances } from "@scorewarrior/rubens_web_lib/lib/hub-instances";
import axios from "axios";

export async function registrationV4(
    regData: RegistrationProtocol,
    isLpReg: boolean
): Promise<JRpcResponse<RegistrationResponse>> {
    try {
        const marketingResponse = await Axios.get(Url.getNoLangUrl('marketing/getData'));

        const hubApiBuilder = new HubApiBuilder(Url.getHubClientRestapiUrl(), Url.getHubClientRestapiUrl());
        const hubApi = hubApiBuilder.getForGame(getCurrentGame());

        let hubResponse: RegistrationResponse | HubApiError;
        switch (regData.lp) {
            case 4:
                hubResponse = await hubApi.registrationWithConfirmation(
                    window.app.deviceIdentifier,
                    regData.email,
                    regData.email_confirm,
                    window.app.config.current_entry_point,
                    window.app.config.locale,
                    regData.state,
                    regData.confidence,
                    marketingResponse.data
                )
                break;
            case 2:
                hubResponse = await hubApi.registrationEmailOnly(
                    window.app.deviceIdentifier,
                    regData.email,
                    window.app.config.current_entry_point,
                    window.app.config.locale,
                    regData.state,
                    regData.confidence,
                    marketingResponse.data
                )
                break;
            case 1:
            case 3:
            default:
                hubResponse = await hubApi.registrationWithPassword(
                    window.app.deviceIdentifier,
                    regData.email,
                    regData.password,
                    window.app.config.current_entry_point,
                    window.app.config.locale,
                    regData.state,
                    regData.confidence,
                    marketingResponse.data
                )
        }

        let url = getUrlToLoginViaToken(hubResponse.token, hubResponse.suid);
        url = addLoginQueryParams(url);
        await axios.get(url);

        GtmSender.fireClient(systemEvents.EMAIL_REG_SUCCESS);
        if (isLpReg) {
            GtmSender.fireClient(systemEvents.IS_LANDING_REG);
        }

        if (!('error' in hubResponse)) {
            clearRefCookie();
        }

        return {
            jsonrpc: '2.0',
            result: hubResponse
        };
    } catch (exception) {
        console.error(exception);
        window.Sentry.captureException(exception);
        return {
            jsonrpc: '2.0',
            error: {
                code: exception.code,
                message: exception.message,
                data: {}
            }
        };
    }
}

function getCurrentGame(): HubInstances {
    return getProjectNameByCurrentPlatform() === ProjectName.TOTALBATTLE
        ? HubInstances.TOTALBATTLE
        : HubInstances.TRIUMPH;
}

function clearRefCookie(): void {
    $.cookie('ref_collection', '', {
        domain: `.${window.app.config.domain}`,
        secure: true,
        path: '/',
        expires: -1
    });
}
